import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('mapItem', 'mapItems');

const customActions = {
  async CREATE_mapItemModel({ rootGetters }, obj) {
    const {
      orgId,
      logisticsHead,
      medicalHead,
      name,
      provincialLeader,
      regionalLeader,
      securityHead,
      state,
      strokeColour,
      leaderContact,
    } = obj;
    const mapItemModel = {
      orgId,
      logisticsHead,
      medicalHead,
      name,
      provincialLeader,
      regionalLeader,
      securityHead,
      state,
      strokeColour,
      leaderContact,
      areaPoints: obj.points?.geography?.wellKnownText ?? null,
      passthroughPoint: obj.passthroughPoint?.geography?.wellKnownText ?? null,
      pickupPoint: obj.pickupPoint?.geography?.wellKnownText ?? null,
    };
    const data = await odata.o(rootGetters)
      .post('newMapItem', mapItemModel)
      .query();
    return data;
  },
  async UPDATE_mapItemModel({ rootGetters }, obj) {
    const {
      id,
      orgId,
      logisticsHead,
      medicalHead,
      name,
      provincialLeader,
      regionalLeader,
      securityHead,
      state,
      strokeColour,
      leaderContact,
    } = obj;
    const mapItemModel = {
      id,
      orgId,
      logisticsHead,
      medicalHead,
      name,
      provincialLeader,
      regionalLeader,
      securityHead,
      state,
      strokeColour,
      leaderContact,
      areaPoints: obj.points?.geography?.wellKnownText ?? null,
      passthroughPoint: obj.passthroughPoint?.geography?.wellKnownText ?? null,
      pickupPoint: obj.pickupPoint?.geography?.wellKnownText ?? null,
    };
    const data = await odata.o(rootGetters)
      .post('updateMapItem', mapItemModel)
      .query();
    return data;
  },
  async LOAD_mapItems({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('mapItems')
      .query({ $filter: 'IsDeleted eq false' });
    commit('SET_mapItems', data);
    return data;
  },
  async LOAD_myLocation({ rootGetters, commit }, pos) {
    try {
      const data = await odata.o(rootGetters)
        .post('findMe', pos)
        .query();
      commit('SET_myLocation', data);
      return data;
    } catch (error) {
      commit('SET_myLocation', null);
      return null;
    }
  },
};

export default { ...actions, ...customActions };
